import React from 'react';
import useStyle from './cartFooter.style';
import { ButtonWithText } from '../../../atoms/Buttons/ButtonWithText';
import { classNames } from '../../../../helpers/style/classNames';

export interface CartFooterProps {
  variant?: 'recap' | 'reporting' | 'panier';
  nbProducts: number;
  totalPanier: string;
  fraisDePort?: string;
  onClickCommander: () => void;
  onClickModif: () => void;
  isOrderButtonDisable?: boolean;
  ngoContribution: {
    isContributing: boolean;
    amount: number;
  };
}

export const CartFooter = ({
  variant = 'reporting',
  nbProducts,
  totalPanier,
  fraisDePort,
  onClickCommander,
  onClickModif,
  isOrderButtonDisable,
  ngoContribution
}: CartFooterProps) => {
  const classes = useStyle();

  return (
    <div className={classes.root}>
      <p className={classes.text}>{nbProducts} article(s)</p>
      {ngoContribution.isContributing && (
        <p className={classes.text}>
          Contribution ONG : {ngoContribution.amount} €
        </p>
      )}
      {fraisDePort && (
        <p className={classes.text}>Frais de port : {fraisDePort} €</p>
      )}

      <p className={classes.text}>Prix total du panier :</p>
      <p className={classNames([classes.text, classes.price])}>
        {totalPanier}€
      </p>
      {(variant === 'reporting' || variant === 'panier') && (
        <ButtonWithText
          variant={'primaryGreen'}
          content={'Passer la commande'}
          onClick={onClickCommander}
          disabled={isOrderButtonDisable}
        />
      )}
      {(variant === 'recap' || variant === 'reporting') && (
        <ButtonWithText
          variant={
            variant === 'reporting'
              ? 'secondaryGreen'
              : variant === 'recap'
              ? 'danger'
              : 'primaryGreen'
          }
          content={
            variant === 'reporting'
              ? 'Modifier le panier'
              : variant === 'recap' && 'Retourner au panier'
          }
          onClick={onClickModif}
        />
      )}
    </div>
  );
};
